import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { indicatorStyles } from './styles'

/**
 * CarouselIndicators - Navigation controls for the campaign carousel
 *
 * Displays:
 * - Left/right arrow buttons for navigation
 * - Pagination dots indicating current page
 * - Visual feedback for disabled states
 *
 * @param {Object} props
 * @param {number} props.currentPage - Current active page (0-based)
 * @param {number} props.totalPages - Total number of pages
 * @param {Function} props.onPageChange - Callback when a dot is clicked
 * @param {Function} props.onPrevious - Callback for previous button
 * @param {Function} props.onNext - Callback for next button
 * @param {boolean} props.isAtStart - Whether carousel is at the start
 * @param {boolean} props.isAtEnd - Whether carousel is at the end
 * @param {Object} props.classes - JSS styles injected by react-jss
 */
const CarouselIndicators = ({
  classes,
  currentPage,
  totalPages,
  onPageChange,
  onPrevious,
  onNext,
  isAtStart,
  isAtEnd,
}) => {
  /**
   * Generate array of page indices for dot indicators
   */
  const pages = Array.from({ length: totalPages }, (_, index) => index)

  return (
    <div className={classes.indicators} cypress_id="carouselIndicators">
      {/* Previous button */}
      <button
        className={classNames(classes.arrowButton, {
          [classes.arrowButtonDisabled]: isAtStart,
        })}
        onClick={onPrevious}
        disabled={isAtStart}
        aria-label="Previous page"
        cypress_id="carouselPreviousButton"
      >
        <ChevronLeftIcon />
      </button>

      {/* Pagination dots */}
      <div className={classes.dotsContainer} cypress_id="carouselDots">
        {pages.map(pageIndex => (
          <button
            key={pageIndex}
            className={classNames(classes.dot, {
              [classes.dotActive]: pageIndex === currentPage,
            })}
            onClick={() => onPageChange(pageIndex)}
            aria-label={`Go to page ${pageIndex + 1}`}
            aria-current={pageIndex === currentPage ? 'true' : 'false'}
            cypress_id={`carouselDot-${pageIndex}`}
          />
        ))}
      </div>

      {/* Next button */}
      <button
        className={classNames(classes.arrowButton, {
          [classes.arrowButtonDisabled]: isAtEnd,
        })}
        onClick={onNext}
        disabled={isAtEnd}
        aria-label="Next page"
        cypress_id="carouselNextButton"
      >
        <ChevronRightIcon />
      </button>
    </div>
  )
}

export default injectStyles(indicatorStyles)(CarouselIndicators)
